import { useFormikContext } from 'formik';

import { AlertSettingsFormValues } from './types';

export function useNotificationChannel(index: number) {
  const { values } = useFormikContext<AlertSettingsFormValues>();
  return values.notificationChannels[index];
}
